<template>
    <div id="header" class="d-flex flex-row justify-content-start">
        <div id="ibisLogo"></div>
        <div id="siteName"  class="d-flex flex-column align-items-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136 2"><g id="Txt"><rect class="cls-1" width="136" height="2"/></g></g></svg>
            <div class="d-flex flex-row justify-content-center align-items-center"><span>{{siteName}}</span></div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136 2"><g id="Txt"><rect class="cls-1" width="136" height="2"/></g></g></svg>
        </div>

    </div>
</template>

<script>
export default {
  name: 'IbisRatesHorizontalV1Header',
  props: {
    'siteName': ''
  },
  data () {
    return {
    }
  },
  computed: {
    test () {
      return this.$route.query.test
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../_ibis.scss";

#header {
    width: 100%;
    @include heightPercent(223);
    font-family: "Neutraface-Book";
    color: white;
    text-transform: uppercase;
    text-align: center;
    background-color: #5B5152;

    #ibisLogo {
        @include widthPercent(223);
        height: 100%;
        background: url(./assets/logo.png) no-repeat;
        background-size: contain;
    }

    #siteName {
        width: 100%;
        height: 100%;
        @include fontSize(47);

        svg {
            @include widthPercent(136);
            @include heightPercent(2);
            margin : 1rem;
            .cls-1 {
                fill:#78c7ce;
            }
        }

        div span{
            font-family: "Neutraface-Bold";

            &::first-line {
                 font-family: "Neutraface-Book";
            }
        }


    }
}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/header.vue